import React from "react";
import { Layout } from "antd";
import SetPasswordPage from "../components/login/SetPasswordComponent";

export default function Login() {
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <SetPasswordPage />
    </Layout>
  );
}
